export default __webpack_public_path__ + "images/article-placeholder.814d08aa462e51de42d7ae39cf3af896.png";